document.addEventListener('DOMContentLoaded', function () {
  const popupLinks = document.querySelectorAll(".popup-link");
  const header = document.querySelector('.header-wrapper');
  let currentPopup = null;

  popupLinks.forEach((popupLink, index) => {
    const popupContainer = document.getElementById(`myPopup${index + 1}`);
    const closePopup = popupContainer.querySelector(".close-popup");
    const popIframe = popupContainer.querySelector('iframe');

    popupLink.addEventListener('click', () => {
      // Close the current popup if it's open
      if (currentPopup) {
        currentPopup.style.display = "none";
      }

      popupContainer.style.display = "block";
      popIframe.src = popupLink.dataset.id;
      header.style.display = "none";
      document.querySelector('body').style.overflowY = 'hidden';
      currentPopup = popupContainer;
    });

    closePopup.addEventListener("click", () => {
      popupContainer.style.display = "none";
      header.style.display = "block";
      document.querySelector('body').style.overflowY = 'scroll';
    });
  });
});


